'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.parse = exports.StatusPropType = exports.Status = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _lodash = require('lodash');

/**
 *
 */
var Status = exports.Status = {
	PENDING: 0,
	OPEN: 1,
	CLOSED: 2
};

var StatusPropType = exports.StatusPropType = _react.PropTypes.oneOf((0, _lodash.values)(Status));

/**
 *	Ensures that all values have a proper type.
 */
var parse = exports.parse = function parse(discussion) {
	return _extends({}, discussion, {
		status: 'status' in discussion ? (0, _lodash.toNumber)(discussion.status) : Status.PENDING
	});
};